///<reference path="../headers/common.d.ts" />

import {Emitter} from './utils/emitter';

var appEvents = new Emitter();
export default appEvents;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./public/app/core/app_events.ts